module.exports = __webpack_public_path__ + "img/modal-bg.eb9d153a.png";